let config = [{
        name: "帐户余额",
        type: "module-name"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "icon_url",
                name: "封面图片",
                type: "img",
                memo: "建议尺寸：60px*60px"
            },
            {
                key: "name",
                name: "文案",
                type: "text",
                memo: "文案最多30个汉字",
                max: 30
            }
        ]
    },
    {
        key: "property_data",
        name: "小标题",
        type: "radio-box-input",
        "radio-name": "sub_title_type",
        "show-value": 2,
        content: [{
                key: "sub_title_type",
                name: "小标题",
                type: "radio-box",
                "radio-list": [{
                        label: "显示余额",
                        value: 1
                    },
                    {
                        label: "显示文案",
                        value: 2
                    }
                ]
            },
            {
                key: "sub_title",
                name: "文案",
                "label-show": false,
                type: "text",
                memo: "文案最多30个汉字",
                max: 30
            }
        ]
    }
];

export default config;